<template>
  <b-card title="Documents">
    <table class="mt-7 mt-xl-0 w-100">
      <tr v-for="file in userData.files" :key="file.filename">
        <th class="pb-50">
          <span class="font-weight-bold">{{ file.filename }}</span>
        </th>
        <td class="pb-50">
          <a target="_blank" :href="file.downloadURL">
            Open
          </a>
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getAddress(address) {
      let str = ''
      str = `${address.add_line_1} ${address.post_code} ${address.city} ${address.state}`
      return str
    },
  },
}
</script>

<style></style>
